import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import React, { useRef, useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";

const slugify = (str) =>
  String(str || '')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // strip accents
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // non-alnum to hyphen
    .replace(/^-+|-+$/g, ''); // trim hyphens

const translationKeys = {
  TITLE: "Explore Our Cutting-edge Products",
  DISCOVER: "discover",
  READ_MORE: "Read more",
};

const ProductArea = () => {
  const historyData = [
        { id: 1, img: "/assets/img/products/resizedPictures/FA_Shop_2.png", year: "FLAKE ANALYZER", title: "Journey was started" },
    { id: 2, img: "/assets/img/products/resizedPictures/FSR_3059.png", year: "FLAKE SORTER", title: "Best agency in new york" },
    { id: 3, img: "/assets/img/products/resizedPictures/QC_RMR_2.png", year: "QC (control qualité)", title: "Category design awards" },

    { id: 4, img: "/assets/img/products/resizedPictures/Aquila_Sea_1.png", year: "AQUILA SERIES", title: "Journey was started" },
    //  { id: 2, img: "/assets/img/products/resizedPictures/Black-Sorter.png", year: "AQUILA SERIES", title: "Best agency in new york" },
    // { id: 3, img: "/assets/img/products/resizedPictures/Micro-Flake-Sorter.png", year: "MICRO-FLAKE SORTER", title: "Best design award in" },
    // { id: 4, img: "/assets/img/products/resizedPictures/Melt-Sorter.png", year: "MELT SORTER", title: "Category design awards" },
  ];

  const swiperRef = useRef(null);

  const nextSlide = () => swiperRef.current?.slideNext();
  const prevSlide = () => swiperRef.current?.slidePrev();

  // Translation
  const { currentLanguage, translateContent } = useLanguage();
  const [translations, setTranslations] = useState(translationKeys);

  useEffect(() => {
    const translateAll = async () => {
      const keys = Object.keys(translationKeys);
      const newTranslations = {};
      const translationPromises = keys.map(async (key) => {
        try {
          const translated = await translateContent(translationKeys[key]);
          newTranslations[key] = translated || translationKeys[key];
        } catch {
          newTranslations[key] = translationKeys[key];
        }
      });
      await Promise.all(translationPromises);
      setTranslations(newTranslations);
    };
    translateAll();
  }, [currentLanguage, translateContent]);

  return (
    <section className="blog__area grey-bg-5 pb-80 pt-80">
      <div className="container">
        <div className="row">
          <div className="col-xl-6">
            <div className="section__wrapper mb-55">
              <h4 className="section__title">{translations.TITLE}</h4>
              <div className="r-text">
                <span>{translations.DISCOVER}</span>
              </div>
            </div>
          </div>

          {/* Buttons and Swiper in one row */}
          <div className="row align-items-center m-0 p-0">
            {/* Left button */}
            <div className="col-1 d-flex justify-content-center">
              <button
                onClick={prevSlide}
                className="bg-white/70 hover:bg-white rounded-full shadow"
                aria-label="Previous"
                style={{
                  padding: "12px",
                  marginLeft: "0",
                  marginRight: "0",
                }}
              >
                <ChevronLeft size={15} className="d-block d-md-none" style={{ padding: "0", margin: "0" }} />
                <ChevronLeft size={24} className="d-none d-md-block" />
              </button>
            </div>

            {/* Swiper */}
            <div className="col-10">
              <Swiper
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                spaceBetween={30}
                slidesPerView={4}
                loop
                autoplay={{ delay: 6000 }}
                modules={[Autoplay]}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  550: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  992: { slidesPerView: 3 },
                  1200: { slidesPerView: 4 },
                  1400: { slidesPerView: 4 },
                }}
              >
                {historyData.map((history) => {
                  const slug = slugify(history.year);
                  const to = `/products/${slug}`;
                  return (
                    <SwiperSlide key={history.id}>
                      <div className="history__item mb-30">
                        <div className="sm-item-thumb w-img">
                          <Link to={to} target="_blank" rel="noopener noreferrer" aria-label={`${history.year} details`}>
                            <img
                              src={history.img}
                              alt={history.year}
                              style={{
                                width: "110%",
                                height: "250px",
                                objectFit: "cover",
                                objectPosition: "top ",
                                padding: "10px"
                              }}
                            />
                          </Link>
                          <div className="sm-item-tag">
                            <span style={{ width: "160px" }}>{history.year}</span>
                          </div>
                        </div>
                        <div className="sm-item-content" style={{ textAlign: "center" }}>
                          <Link className="link-btn" style={{ color: "#000", textDecoration: "none" }} to={to} target="_blank" rel="noopener noreferrer">
                            {translations.READ_MORE}{" "}
                            <i className="fas fa-long-arrow-right" style={{ marginLeft: "5px", color: "#000" }}></i>
                          </Link>
                        </div>
                      </div>
                    </SwiperSlide>
                  )
                })}
              </Swiper>
            </div>

            {/* Right button */}
            <div className="col-1 d-flex justify-content-center">
              <button
                onClick={nextSlide}
                className="bg-white/70 hover:bg-white rounded-full shadow"
                aria-label="Next"
                style={{
                  padding: "12px",
                  marginLeft: "0",
                  marginRight: "0",
                }}
              >
                <ChevronRight size={15} className="d-block d-md-none" style={{ padding: "0", margin: "0" }} />
                <ChevronRight size={24} className="d-none d-md-block" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductArea;


